const backgroundCheck = {
  // Common errors
  err_api_key_not_present: {
    message: 'API key is missing. Please add your API key in Settings.',
  },
  err_background_check_creation_failed: {
    message: 'Failed to create background check. Please try again.',
  },
  err_candidate_email_not_found: {
    message: 'Candidate does not have an email address. Add one and try again.',
  },

  // Certn errors
  err_certn_case_order_failed: {
    message: 'Unable to send Certn background check. Try again later.',
  },
  err_certn_invalid_request: {
    message: 'Invalid request. Please check the package and try again.',
  },
  err_certn_auth_failed: {
    message: 'Failed to authenticate with Certn. Please check your API key.',
  },
  err_certn_api_unavailable: {
    message: 'Certn service is currently unavailable. Please try again later.',
  },
  err_certn_integration_not_found: {
    message:
      'Certn integration is not connected. Please enable it in Settings.',
  },
  err_no_active_certn_integration: {
    message:
      'No active Certn integration found. Please re-authenticate your integration to send assessments.',
  },
  err_certn_packages_fetch_failed: {
    message:
      'Certn API key is invalid. Re-authenticate your integration to send assessments.',
  },
  err_webhook_secret_not_present: {
    message: 'Webhook secret is required. Please enter your webhook secret.',
  },
  err_unexpected_error: {
    message: 'An unexpected error occurred. Please try again.',
  },

  // Zinc errors
  err_zinc_packages_fetch_failed: {
    message: 'Failed to load Zinc packages. Please try again.',
  },
  err_zinc_integration_not_found: {
    message: 'Zinc integration not connected. Please enable it in Settings.',
  },
  err_zinc_candidate_contact_missing: {
    message:
      'Candidate contact information is missing. Please add it and try again.',
  },
  err_zinc_candidate_email_missing: {
    message: 'Candidate email is missing. Please add it and try again.',
  },
  err_zinc_candidate_first_name_missing: {
    message: 'Candidate first name is missing. Please add it and try again.',
  },
  err_zinc_check_creation_failed: {
    message: 'Unable to create Zinc background check. Please try again.',
  },
  err_zinc_check_creation_failed_missing_cv: {
    message:
      'Unable to create Zinc background check. Candidate CV is required.',
  },
  err_zinc_invalid_request: {
    message: 'Invalid request. Please check the package and try again.',
  },
  err_zinc_auth_failed: {
    message: 'Failed to authenticate with Zinc. Please check your API key.',
  },
  err_zinc_api_unavailable: {
    message: 'Zinc service is currently unavailable. Please try again later.',
  },
  err_zinc_invitation_already_exists: {
    message: 'Candidate has already been invited for a Zinc background check.',
  },
  err_client_error: {
    message: 'Invalid Zinc API key. Double-check the key and try again.',
  },

  // SpringVerify errors
  err_springverify_packages_fetch_failed: {
    message: 'Failed to load SpringVerify packages. Please try again.',
  },
  err_springverify_integration_not_found: {
    message:
      'SpringVerify integration not connected. Please enable it in Settings.',
  },
  err_springverify_candidate_contact_missing: {
    message:
      'Candidate contact information is missing. Please add it and try again.',
  },
  err_springverify_candidate_email_missing: {
    message: 'Candidate email is missing. Please add it and try again.',
  },
  err_springverify_candidate_name_missing: {
    message: 'Candidate name is missing. Please add it and try again.',
  },
  err_springverify_insufficient_credits: {
    message:
      'Insufficient SpringVerify credits. Please top up your balance and try again.',
  },
  err_springverify_invalid_request: {
    message: 'Invalid request. Please check the package and try again.',
  },
  err_springverify_check_creation_failed: {
    message:
      'Unable to create SpringVerify background check. Please try again.',
  },
};

export default backgroundCheck;
